import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import FadeIn from '../../components/base/FadeIn';
import iletisimHero from '../../assets/images/hero-iletisim.jpg';
import { INSTAGRAM_PROFILE_URL, TEL_HREF, WHATSAPP_CHAT_URL } from '../../config/contactLinks';

const contactCards = [
  { icon: 'ri-whatsapp-line', label: 'WhatsApp', value: '0543 191 0851', sub: '7/24 mesaj atabilirsiniz', href: WHATSAPP_CHAT_URL, color: 'text-[#25D366]', bg: 'bg-[#25D366]/10' },
  { icon: 'ri-instagram-line', label: 'Instagram', value: '@nigpak.temizlik', sub: 'Referans fotoğraflarımız', href: INSTAGRAM_PROFILE_URL, color: 'text-pink-400', bg: 'bg-pink-50' },
  { icon: 'ri-mail-line', label: 'E-Posta', value: 'nigpaktemizlik@gmail.com', sub: 'Kurumsal teklifler için', href: 'mailto:nigpaktemizlik@gmail.com', color: 'text-gold', bg: 'bg-gold/10' },
  { icon: 'ri-map-pin-line', label: 'Konum', value: 'Niğde Merkez', sub: 'Tüm ilçelere hizmet', href: null, color: 'text-navy', bg: 'bg-navy/5' },
];

const hours = [
  { day: 'Pazartesi – Cuma', time: '08:00 – 18:00' },
  { day: 'Cumartesi', time: '09:00 – 16:00' },
  { day: 'Pazar', time: 'Kapalı' },
];

export default function IletisimPage() {
  return (
    <PageLayout>
      <PageHero
        label="Bize Ulaşın"
        title="İletişim"
        subtitle="Ücretsiz keşif ve fiyat teklifi için bize ulaşın. En kısa sürede geri dönüş garantisi."
        bgImage={iletisimHero}
      />

      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8">

          {/* Contact cards */}
          <FadeIn className="mb-6">
            <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em] mb-4">İletişim Kanalları</p>
            <h2 className="text-3xl font-extrabold text-navy mb-10">Bize Ulaşın</h2>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
            {contactCards.map((c, i) => {
              const inner = (
                <div className="flex items-center gap-4 bg-white border border-gray-100 rounded-xl p-5 hover:border-gold/40 transition-colors h-full">
                  <div className={`w-12 h-12 flex items-center justify-center ${c.bg} rounded-xl shrink-0`}>
                    <i className={`${c.icon} ${c.color} text-2xl`}></i>
                  </div>
                  <div>
                    <p className="text-[11px] text-gray-400 font-medium uppercase tracking-wider mb-0.5">{c.label}</p>
                    <p className="text-navy font-bold text-sm">{c.value}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{c.sub}</p>
                  </div>
                </div>
              );
              return (
                <FadeIn key={c.label} delay={i * 0.07}>
                  {c.href ? (
                    <a href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined}
                      rel={c.href.startsWith('http') ? 'nofollow noreferrer' : undefined} className="cursor-pointer block h-full">
                      {inner}
                    </a>
                  ) : <div>{inner}</div>}
                </FadeIn>
              );
            })}
          </div>

          {/* Hours + CTA */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <FadeIn>
              <div className="bg-navy text-white rounded-xl p-7 h-full">
                <div className="flex items-center gap-2 mb-6">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-time-line text-gold"></i></span>
                  <span className="font-bold text-sm uppercase tracking-wider">Çalışma Saatleri</span>
                </div>
                <div className="space-y-4">
                  {hours.map(row => (
                    <div key={row.day} className="flex justify-between items-center border-b border-white/10 pb-4 last:border-0 last:pb-0">
                      <span className="text-white/60 text-sm">{row.day}</span>
                      <span className={`font-bold text-sm ${row.time === 'Kapalı' ? 'text-white/30' : 'text-gold'}`}>{row.time}</span>
                    </div>
                  ))}
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.1}>
              <div className="bg-[#f7f8fc] rounded-xl p-7 h-full flex flex-col justify-between">
                <div>
                  <p className="text-gold text-[11px] font-bold uppercase tracking-[0.2em] mb-3">Hızlı İletişim</p>
                  <h3 className="text-2xl font-extrabold text-navy mb-3">Hemen Teklif Alın</h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-6">
                    WhatsApp üzerinden yazmanız yeterli. 2 saat içinde size geri dönüş garantisi veriyoruz.
                  </p>
                </div>
                <div className="flex flex-col gap-3">
                  <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
                    className="flex items-center justify-center gap-2 bg-navy hover:bg-gold text-white font-bold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-whatsapp-line text-base"></i>
                    WhatsApp ile Teklif Al
                  </a>
                  <a href={TEL_HREF}
                    className="flex items-center justify-center gap-2 border border-gray-200 hover:border-gold text-navy hover:text-gold font-bold px-6 py-3.5 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                    <i className="ri-phone-line text-base"></i>
                    0543 191 0851
                  </a>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Map */}
          <FadeIn className="mt-10">
            <div className="rounded-xl overflow-hidden border border-gray-100" style={{ height: 340 }}>
              <iframe
                title="NiğPak Temizlik Konum"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49184.91!2d34.6742!3d37.9667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d3ea4f1e8a1b1b%3A0x3e3e3e3e3e3e3e3e!2sNi%C4%9Fde%20Merkez%2C%20Ni%C4%9Fde!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
                width="100%"
                height="340"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </FadeIn>
        </div>
      </section>
    </PageLayout>
  );
}
